'use client';
import { createStorage } from '../createStorage/createStorage.js';

function useLocalStorage(props) {
    return createStorage("localStorage", "useLocalStorage")(props);
}

export { useLocalStorage };
